import {Friend} from '../../types/farming'
import {useEffect, useState} from "react";
import {getFriends, LOADED} from "../../communication/communication";

import {Loading, LoadingCenter, LoadingList} from "../Common/Loading/LoadingPlaceholder";
import {loading, Wrapped} from "../../communication/wrapped";
import {InviteFriendButton} from "./InviteFriendsButton";
import {ClaimFriendsButton} from "./FriendsClaimButton";
import {FriendList} from "./FriendList";
import {BasicPageLayout, BasicSubscript} from "../Common/Elements/BasicPageLayout";

import './FriendsView.css'
import {useTranslation} from "react-i18next";

const emptyFriends: Wrapped<Friend[]> = loading([])

const loadingButtons = <>
    <div className="friends-buttons">
        <LoadingCenter className="l-rounded loading-invite-friend-button"/>
        <LoadingCenter className="l-rounded loading-friends-claim-button"/>
    </div>
    <LoadingCenter className="l-rounded l-margin loading-button-subscript"/>
</>

const loadingContent = <div>
    <Loading className="loading-friends-board-header"/>
    <br/>
    <LoadingList count={4} height={"calc(var(--app-height) - 15rem)"}/>
</div>

const friendsLoading = <BasicPageLayout height="calc(var(--app-height) - 9rem)" content={loadingContent} button={loadingButtons}/>


export function FriendsView() {
    const [friends, setFriends] = useState(emptyFriends)
    const {t} = useTranslation()

    const fetchFriends = () => {
        getFriends().then(r => setFriends(r))
    }

    useEffect(() => {
        fetchFriends()
    }, []);

    if (friends.statusCode !== LOADED) return friendsLoading

    let bonus = friends.data!.reduce((a, c) => a + c.balance_diff, 0) / 10;

    const content =
        <FriendList friends={friends.data!}/>

    const buttons = <>
        <div className="friends-buttons">
            <div className="mini-margin-right"><InviteFriendButton/></div>
            <div className="mini-margin-left"><ClaimFriendsButton bonus={+bonus.toFixed(0)} fetchFriends={fetchFriends}/></div>
        </div>
        <BasicSubscript text={t("____friendsButtonSubscript")}/>
    </>

    return <BasicPageLayout height="calc(var(--app-height) - 9rem)" content={content} button={buttons}/>
}